import { render, staticRenderFns } from "./fav-dialog.vue?vue&type=template&id=1735eb2e&scoped=true&"
import script from "./fav-dialog.vue?vue&type=script&lang=js&"
export * from "./fav-dialog.vue?vue&type=script&lang=js&"
import style0 from "./fav-dialog.vue?vue&type=style&index=0&id=1735eb2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1735eb2e",
  null
  
)

component.options.__file = "fav-dialog.vue"
export default component.exports